var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateBlankMatter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 623,
    height: 508,
    viewBox: "0 0 623 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 2.934C250.1 -0.978 261.9 -0.978 272.5 2.934L480.5 79.196C499.4 86.136 512 104.116 512 124.316V383.616C512 403.716 499.4 421.716 480.5 428.616L272.5 504.016C261.9 508.816 250.1 508.816 239.5 504.016L31.48 428.616C12.57 421.716 0 403.716 0 383.616V124.316C0 104.116 12.57 86.136 31.48 79.196L239.5 2.934ZM261.5 32.976C257.1 31.676 254 31.676 250.5 32.976L44.14 108.616L256 191.016L467.9 108.616L261.5 32.976ZM42.49 398.616L240 471.016V219.916L32 138.216V383.616C32 390.316 36.19 396.316 42.49 398.616ZM272 471.016L469.5 398.616C475.8 396.316 480 390.316 480 383.616V138.216L272 219.916V471.016Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 130,
    r: 129,
    fill: "#E1E1E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.5,
    cy: 129.5,
    r: 85.5,
    stroke: "black",
    strokeWidth: 32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540 129.5C540 133.37 536.865 136.502 533 136.502H501.5V168.002C501.5 171.872 498.365 175 494.5 175C490.635 175 487.5 171.872 487.5 168.002V136.502H456C452.135 136.502 449 133.37 449 129.5C449 125.63 452.135 122.502 456 122.502H487.5V91.0022C487.5 87.1325 490.635 84 494.5 84C498.365 84 501.5 87.1325 501.5 91.0022V122.502H533C536.872 122.5 540 125.628 540 129.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBlankMatter);
export default __webpack_public_path__ + "static/media/create_blank_matter.dc60bb6268d0da275f8212d79913a2bb.svg";
export { ForwardRef as ReactComponent };